/**
 * Klaviyo k-hub Overlay Prevention Script
 * Prevents Klaviyo's overlay from interfering with save buttons
 * WITHOUT breaking any existing functionality
 */

(function() {
  'use strict';
  
  // Configuration - only target the specific buttons that need protection
  const CONFIG = {
    saveButtonSelectors: [
      '.save_button_style',
      '#save-blog-btn'
    ]
  };
  
  let isInitialized = false;
  
  /**
   * Simple function to prevent Klaviyo from attaching overlay to save buttons
   */
  function preventKlaviyoOverlay() {
    if (isInitialized) return;
    
    const saveButtons = document.querySelectorAll(CONFIG.saveButtonSelectors.join(','));
    
    if (saveButtons.length === 0) {
      // No save buttons found yet, try again later
      setTimeout(preventKlaviyoOverlay, 500);
      return;
    }
    
    saveButtons.forEach(button => {
      // Only remove Klaviyo-specific attributes that cause overlay attachment
      const klaviyoAttributes = [
        'data-klaviyo-overlay',
        'data-k-hub-target',
        'data-klaviyo-trigger'
      ];
      
      klaviyoAttributes.forEach(attr => {
        if (button.hasAttribute(attr)) {
          button.removeAttribute(attr);
        }
      });
      
      // IMPORTANT: Don't change the href at all - this breaks functionality!
      // The existing save functionality needs the original href to work properly
      
      // Add a mutation observer to prevent Klaviyo from adding overlay attributes
      if (!button._klaviyoObserver) {
        button._klaviyoObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes') {
              const attrName = mutation.attributeName;
              const target = mutation.target;
              
              // If Klaviyo tries to add overlay attributes, remove them immediately
              if (klaviyoAttributes.includes(attrName)) {
                target.removeAttribute(attrName);
              }
            }
          });
        });
        
        button._klaviyoObserver.observe(button, {
          attributes: true,
          attributeFilter: ['data-klaviyo-overlay', 'data-k-hub-target', 'data-klaviyo-trigger']
        });
      }
    });
    
    isInitialized = true;
    console.log('[Klaviyo Fix] Save buttons protected from overlay - functionality preserved');
  }
  
  /**
   * Monitor for Klaviyo trying to re-attach overlay
   */
  function monitorKlaviyo() {
    // Check periodically if Klaviyo is trying to re-attach
    setInterval(function() {
      const kHubElement = document.querySelector('#k-hub');
      if (kHubElement) {
        // Klaviyo is active, re-apply protection
        preventKlaviyoOverlay();
      }
    }, 2000);
  }
  
  /**
   * Initialize the protection
   */
  function init() {
    // Start protecting buttons immediately
    preventKlaviyoOverlay();
    
    // Set up monitoring
    monitorKlaviyo();
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also start when window loads (for late-loading scripts)
  window.addEventListener('load', init);
  
})();
